import { cScene } from "./cScene";



export class cSceneGlobal extends cScene {

  init(){
    super.init()
  }

  create(){
    super.create()
  }


}